<template>
  <div class="worksheet" style="max-width: 1000px; margin: auto;">
    <div style="margin-top: 50px;" v-if="loading" v-loading="loading" element-loading-spinner="atom-audit-loader"></div>
    <div v-if="!loading">
      <el-button class="pull-right print-hidden" round style="margin-top: 0px;" icon="mdi mdi-details" size="mini" @click="saveWorksheet">Download</el-button>
      <div v-for="(worksheet, index) in worksheets" :key="worksheet.patientNumber" class="page-break" style="margin-bottom: 50px;">
        <TenantReportHeader v-if="index === 0"></TenantReportHeader>
        <h1 class="header-row">Professional Fee Review Worksheet</h1>
        <ProWorksheet :worksheet="worksheet" :codeTypesParam="codeTypesParam"></ProWorksheet>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapState, mapActions } from 'vuex'
  import { format, parseISO } from 'date-fns'
  import ProWorksheet from './ProWorksheet.vue'
  import TenantReportHeader from '@/views/reports/printable/TenantReportHeader.vue'

  import axios from '@/utilities/axios-global'
  export default {
    name: 'Worksheets',
    props: ['proRecordIds'],
    data() {
      return {
        loading: true,
        format: format,
        parseISO: parseISO,
        codeTypesParam: [],
        dropdownsNeeded: ['RecommendationTypes', 'RecommendationRecordTypes', 'RecommendationCodeGroups', 'clients'],
        worksheets: []
      }
    },
    components: {
      ProWorksheet,
      TenantReportHeader
    },
    methods: {
      ...mapActions('managedLists/tenantSetup/', ['GET_TENANT_SETUP']),
      saveWorksheet() {
        window.print()
      }
    },
    created: async function() {
      this.codeTypesParam = this.$route.query.codeTypes ? this.$route.query.codeTypes.split(',')?.map(x => parseInt(x)) : []
      const ids = {
        ids: this.proRecordIds ? this.proRecordIds : this.$route.query.ids,
        codeTypes: this.codeTypesParam
      }
      const url = this.baseApiUrl + '/reviews/pro/worksheets'

      const response = await Promise.all([axios.post(url, ids), this.GET_TENANT_SETUP()])
      this.worksheets = response[0].data
      this.loading = false
    },
    computed: {
      ...mapState('user/', ['baseApiUrl'])
    }
  }
</script>

<style scoped>
  @media print {
    .page-break {
      display: block;
      page-break-after: always;
    }

    .print-hidden {
      display: none;
    }
  }
</style>
